export interface PostHogEnv {
  [key: string]: string | undefined;
  NEXT_PUBLIC_POSTHOG_HOST?: string;
  NEXT_PUBLIC_POSTHOG_KEY?: string;
}

export const DEFAULT_POSTHOG_HOST = 'https://us.i.posthog.com';

export function shouldInitializePostHog(env: PostHogEnv): boolean {
  return Boolean(env.NEXT_PUBLIC_POSTHOG_KEY);
}

export function resolvePostHogHost(env: PostHogEnv): string {
  return env.NEXT_PUBLIC_POSTHOG_HOST ?? DEFAULT_POSTHOG_HOST;
}

export function buildPostHogInitOptions(env: PostHogEnv) {
  return {
    api_host: resolvePostHogHost(env),
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only' as const,
    // kasbly.com and app.kasbly.com share a root domain. Persisting the cookie
    // at the root lets the anonymous visitor ID carry across to the dashboard,
    // so a `signup_cta_clicked` here is stitched to the actual sign-up there
    // once the dashboard calls posthog.identify().
    cross_subdomain_cookie: true,
  };
}

export function buildPostHogPageviewUrl(
  origin: string,
  pathname: string,
  queryString?: string,
): string {
  return queryString ? `${origin}${pathname}?${queryString}` : `${origin}${pathname}`;
}
